import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { cn } from '../../utils/helpers';
export interface FieldsetProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  header?: string;
}
export const Fieldset: React.FC<FieldsetProps> = t0 => {
  const $ = _c(11);
  const {
    children,
    className,
    id,
    header
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("@container", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== header) {
    t2 = header && <legend className="mb-comfy-xl mt-comfy-xl heading-sm">{header}</legend>;
    $[2] = header;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <div className="flex flex-col gap-comfy-sm">{children}</div>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== id || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <fieldset id={id} className={t1}>{t2}{t3}</fieldset>;
    $[6] = id;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};